import React from "react";
import {
  Card,
  CardContent,
  CardHeader,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import { Bar } from "react-chartjs-2";

function LawFirmBondHistoryCard({ graphData }) {
  const options = {
    scales: {
      y: {
        ticks: {
          beginAtZero: true,
          precision: 0,
        },
      },
    },
  };

  return (
    <Grid size={{ xs: 12, md: 6 }}>
      <Card elevation={3} sx={{ borderRadius: "16px" }}>
        <CardHeader
          title="Bond History"
          sx={{
            backgroundColor: "#1565c0", // Consistent blue theme (darker blue)
            color: "white",
            "& .MuiCardHeader-title": {
              fontSize: "1.5rem",
              fontWeight: "600",
            },
          }}
        />
        <CardContent sx={{ padding: 3, marginBottom: 2 }}>
          <Bar data={graphData} options={options} />
        </CardContent>
      </Card>
    </Grid>
  );
}

export default LawFirmBondHistoryCard;
